﻿/* 
Object:         Group change
Description:    Logic and events for the module Group Change 
Used in:        Group change
*/

/*---[ ESLint ]---*/
/*
    global groupchange
*/

window.groupchange = function () {
    
    return {

        /**
         * initialize overview with all the events bound to the buttons.
         * @param {any} userId
         */
        initialize: function (userId) {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Show mode
                mode = "edit";

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("GroupChange/NewItem?userId=" + userId);
            });            
        },

        /**
         * delete a item (param is event data)
         * @param {any} e
         */
        deleteItem: function (e) {
            var event = e;
            var data = this;

            function callbackYes(event, data) {
                // Prevent default behaviour 
                event.preventDefault();

                var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

                // Post Data
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("GroupChange/Delete?groupUserId=" + dataItem.GroupUserID),
                    success: function (responseData) {
                        // Refresh datasource grid 
                        $("#GroupChangeGrid").data("kendoGrid").dataSource.read();
                    }
                });
            }

            function callingCallback() {
                callbackYes(event, data);
            }

            dialog.createDialog(callingCallback, function () { });
        },

        /**
         * update a item (param is event data)
         * @param {any} e
         */
        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));
            
            // Edit mode form
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("GroupChange/EditItem?groupUserId=" + dataItem.GroupUserID + "&breadcrumbLabel=" + dataItem.GroupLabel);
        },

        /**
         * show a item (param is event data)
         * @param {any} e
         */
        showItem: function (e) {
            // Prevent default behaviour
            e.preventDefault();

            // 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Show mode form
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("GroupChange/ShowItem?groupUserId=" + dataItem.GroupUserID + "&breadcrumbLabel=" + dataItem.GroupLabel);
        },

        /**
         * event when the Type selection is changed. according to the selected value some fields will be visible.
         * @param {any} e
         */
        onTypeChanged: function (e) {
            groupchange.setHideTypeFields(this.value());
        },

        /**
         * event when the Type selection is changed. according to the selected value some fields will be visible.
         * @param {any} selectedType
         */
        setHideTypeFields: function (selectedType) {
            main.setHideDivBootstrap("divGroupChange", false);
            main.setHideDivBootstrap("divGroupChangeFrom", false);
            main.setHideDivBootstrap("divGroupChangeTo", false);
            main.setHideDivBootstrap("divWeekdays", false);
            main.setHideDivBootstrap("divGroupChangeStart", false);
            main.setHideDivBootstrap("divGroupChangeStop", false);

            switch (selectedType) {
                case "1":
                    main.setHideDivBootstrap("divGroupChange", true);                               
                    break;
                case "2":
                    main.setHideDivBootstrap("divGroupChangeFrom", true);
                    main.setHideDivBootstrap("divGroupChangeTo", true);
                    break;
                case "4":
                    main.setHideDivBootstrap("divWeekdays", true);
                    main.setHideDivBootstrap("divGroupChangeStart", true);
                    main.setHideDivBootstrap("divGroupChangeStop", true);
                    break;
            }
        }
    }
}();